var ImageZoom = require('image-zoom')

import 'image-zoom/index.css'
